import ApiClient from '../ApiClient';

class CaptainInboxesAPI extends ApiClient {
  constructor() {
    super('captain_inboxes', { accountScoped: true, saas: true });
  }
}

export default new CaptainInboxesAPI();
